import { GameCreateFen } from "src/service/api/lobby/requestResponses";

export const gameModeConst = [1, 2];
export const gameModeText = {
    [GameCreateFen.classic]: "Classic",
    [GameCreateFen.nineHundredSixty]: "960",
};
